import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { all_routes } from "../../../router/all_routes";
import StudentModals from "../studentModals";
import StudentSidebar from "./studentSidebar";
import StudentBreadcrumb from "./studentBreadcrumb";
import Table from "../../../../core/common/dataTable/index";
import { TableData } from "../../../../core/data/interface";
import { leaveData } from "../../../../core/data/json/leaveData";
import { Attendance } from "../../../../core/data/json/attendance";
import UserService from "../../../network/services/UserService";
import { getUser } from "../../../network/auth/Auth";
import moment from "moment";

const StudentLeaves = () => {


  interface TimetableData {
    id: any;
    name: any;
    days: any;
    sessions: any;
    code: any;
    parent_id: any;
    evaluation_type: any;
    subject_ids: any;
    department_id: any;
    active: any;
    fees_term_id: any;
    operating_branch_id: any;
    company_id: any

  }
  interface AttendanceData {
    id: any,
    name: any,
    company_id: any,
    attendance_date: any,
    state: any,
    active: any,
    attendance_line: any
    Apr: any;
    Mar: any;
    Feb: any;
    Jan: any;
    Dec: any;
    Nov: any;
    Oct: any;
    Sep: any;
    Aug: any;
    Jul: any;
    Jun: any;
  }
  const [attendances, setAttendances] = useState<AttendanceData[]>([]);
  const [present, setPresent] = useState(0);
  const [absent, setAbsent] = useState(0);



  const fetchDataUser = async (student_id: any) => {
    UserService.getAttendanceStudent(student_id, (response: any) => {
      if (response?.data && response?.success) {
        console.log(response.data);
        const datas = response?.data.map((item: any, index: number) => ({
          key: index.toString(), // Utilisation de l'index pour la clé
          date: item.attendance_date, // Supposons que 'item' ait une propriété 'date'
          jan: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'jan' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'jan' ? "4" : "5",
          feb: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'feb' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'feb' ? "4" : "5",
          mar: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'mar' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'mar' ? "4" : "5",
          apr: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'apr' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'apr' ? "4" : "5",
          may: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'may' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'may' ? "4" : "5",
          jun: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'jun' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'jun' ? "4" : "5",
          jul: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'jul' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'jul' ? "4" : "5",
          aug: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'aug' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'aug' ? "4" : "5",
          sep: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'sep' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'sep' ? "4" : "5",
          oct: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'oct' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'oct' ? "4" : "5",
          nov: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'nov' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'nov' ? "4" : "5",
          dec: item?.attendance_line[0]?.present === true && moment(item.attendance_date).format('MMM').toLowerCase() === 'dec' ? "1" : item?.attendance_line[0]?.present === false && moment(item.attendance_date).format('MMM').toLowerCase() === 'dec' ? "4" : "5",
        }));
        const counts = response?.data.reduce(
          (acc: { present: number; absent: number }, item: any) => {
            item.attendance_line.forEach((line: any) => {
              if (line.present) {
                acc.present += 1;
              } else {
                acc.absent += 1;
              }
            });
            return acc;
          },
          { present: 0, absent: 0 }
        );


        setPresent(counts.present)
        setAbsent(counts.absent)
        setAttendances(datas)


      }
    });
  };

  const navigation = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (location?.state) {
      fetchDataUser(location?.state?.student?.id)


    }
  }, []);





  const navigeStudentDetails = (student: any) => {
    navigation(routes.studentDetail, { state: { student: student } })
  }

  const navigeStudentTimeline = (student: any) => {
    navigation(routes.studentTimeTable, { state: { student: student } })
  }

  const navigeStudentLeaves = (student: any) => {
    navigation(routes.studentLeaves, { state: { student: student } })
  }

  const navigeStudentExam = (student: any) => {
    navigation(routes.studentResult, { state: { student: student } })
  }




  const routes = all_routes;
  const data = leaveData;
  const data2 = [{
    key: "1",
    date: "01",
    jan: "1",
    feb: "1",
    mar: "1",
    apr: "1",
    may: "2",
    jun: "3",
    jul: "4",
    aug: "5",
    sep: "1",
    oct: "1",
    nov: "1",
    dec: "1",

  }];
  const columns = [
    {
      title: "Leave Type",
      dataIndex: "leaveType",
      sorter: (a: TableData, b: TableData) =>
        a.leaveType.length - b.leaveType.length,
    },
    {
      title: "Leave Date",
      dataIndex: "leaveDate",
      sorter: (a: TableData, b: TableData) =>
        a.leaveDate.length - b.leaveDate.length,
    },
    {
      title: "No of Days",
      dataIndex: "noOfDays",
      sorter: (a: TableData, b: TableData) =>
        parseFloat(a.noOfDays) - parseFloat(b.noOfDays),
    },
    {
      title: "Applied On",
      dataIndex: "appliedOn",
      sorter: (a: TableData, b: TableData) =>
        a.appliedOn.length - b.appliedOn.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <>
          {text === "Approved" ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.status.length - b.status.length,
    },
  ];
  const columns2 = [
    {
      title: "Date | Month",
      dataIndex: "date",
      sorter: (a: TableData, b: TableData) => a.date.length - b.date.length,
    },
    {
      title: "Jan",
      dataIndex: "jan",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.jan.length - b.jan.length,
    },
    {
      title: "feb",
      dataIndex: "feb",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.feb.length - b.feb.length,
    },
    {
      title: "mar",
      dataIndex: "mar",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.mar.length - b.mar.length,
    },
    {
      title: "apr",
      dataIndex: "apr",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.apr.length - b.apr.length,
    },
    {
      title: "may",
      dataIndex: "may",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.may.length - b.may.length,
    },
    {
      title: "jun",
      dataIndex: "jun",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.jun.length - b.jun.length,
    },
    {
      title: "jul",
      dataIndex: "jul",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.jul.length - b.jul.length,
    },
    {
      title: "aug",
      dataIndex: "aug",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.aug.length - b.aug.length,
    },
    {
      title: "sep",
      dataIndex: "sep",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.sep.length - b.sep.length,
    },
    {
      title: "oct",
      dataIndex: "oct",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.oct.length - b.oct.length,
    },
    {
      title: "nov",
      dataIndex: "nov",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.nov.length - b.nov.length,
    },
    {
      title: "dec",
      dataIndex: "dec",
      render: (text: string) => (
        <>
          {text === "1" ? (
            <span className="attendance-range bg-success"></span>
          ) : text === "2" ? (
            <span className="attendance-range bg-pending"></span>
          ) : text === "3" ? (
            <span className="attendance-range bg-dark"></span>
          ) : text === "4" ? (
            <span className="attendance-range bg-danger"></span>
          ) : (
            <span className="attendance-range bg-light"></span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.dec.length - b.dec.length,
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            {/* Page Header */}
            <StudentBreadcrumb />
            {/* /Page Header */}
          </div>
          <div className="row">
            {/* Student Information */}
            <StudentSidebar student={location?.state?.student} />
            {/* /Student Information */}
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  {/* List */}
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <a onClick={() => navigeStudentDetails(location?.state?.student)} className="nav-link active">
                        <i className="ti ti-school me-2" />
                        Student Details
                      </a>
                    </li>
                    <li>
                      <a onClick={() => navigeStudentTimeline(location?.state?.student)} className="nav-link active">
                        <i className="ti ti-table-options me-2" />
                        Time Table
                      </a>
                    </li>
                    <li>
                      <a onClick={() => navigeStudentLeaves(location?.state?.student)} className="nav-link active">
                        <i className="ti ti-calendar-due me-2" />
                        Attendance
                      </a>
                    </li>

                    <li>
                      <a onClick={() => navigeStudentExam(location?.state?.student)} className="nav-link active">
                        <i className="ti ti-bookmark-edit me-2" />
                        Exam &amp; Results
                      </a>
                    </li>
                  </ul>
                  {/* /List */}
                  {/* Leave Nav*/}

                  {/* /Leave Nav*/}
                  <div className="tab-content">

                    {/* Attendance */}
                    <div className="tab-pane fade show active" id="attendance">
                      <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-1">
                          <h4 className="mb-3">Attendance</h4>
                          <div className="d-flex align-items-center flex-wrap">
                            <div className="d-flex align-items-center flex-wrap me-3">
                              <p className="text-dark mb-3 me-2">
                                Last Updated on : 25 May 2024
                              </p>
                              <Link
                                to="#"
                                className="btn btn-primary btn-icon btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0 mb-3"
                              >
                                <i className="ti ti-refresh-dot" />
                              </Link>
                            </div>
                            <div className="dropdown mb-3">
                              <Link
                                to="#"
                                className="btn btn-outline-light bg-white dropdown-toggle"
                                data-bs-toggle="dropdown"
                                data-bs-auto-close="outside"
                              >
                                <i className="ti ti-calendar-due me-2" />
                                Year : 2024 / 2025
                              </Link>
                              <ul className="dropdown-menu p-3">
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                  >
                                    Year : 2024 / 2025
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                  >
                                    Year : 2023 / 2024
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                  >
                                    Year : 2022 / 2023
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="card-body pb-1">
                          <div className="row">
                            {/* Total Present */}
                            <div className="col-md-6 col-xxl-3 d-flex">
                              <div className="d-flex align-items-center rounded border p-3 mb-3 flex-fill">
                                <span className="avatar avatar-lg bg-primary-transparent rounded me-2 flex-shrink-0 text-primary">
                                  <i className="ti ti-user-check fs-24" />
                                </span>
                                <div className="ms-2">
                                  <p className="mb-1">Present</p>
                                  <h5>{present}</h5>
                                </div>
                              </div>
                            </div>
                            {/* /Total Present */}
                            {/* Total Absent */}
                            <div className="col-md-6 col-xxl-3 d-flex">
                              <div className="d-flex align-items-center rounded border p-3 mb-3 flex-fill">
                                <span className="avatar avatar-lg bg-danger-transparent rounded me-2 flex-shrink-0 text-danger">
                                  <i className="ti ti-user-check fs-24" />
                                </span>
                                <div className="ms-2">
                                  <p className="mb-1">Absent</p>
                                  <h5>{absent}</h5>
                                </div>
                              </div>
                            </div>
                            {/* /Total Absent */}


                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-1">
                          <h4 className="mb-3">Attendance</h4>
                          <div className="d-flex align-items-center flex-wrap">
                            <div className="dropdown mb-3 me-3">
                              <Link
                                to="#"
                                className="btn btn-outline-light border-white bg-white dropdown-toggle shadow-md"
                                data-bs-toggle="dropdown"
                              >
                                <i className="ti ti-calendar-due me-2" />
                                This Year
                              </Link>
                              <ul className="dropdown-menu p-3">
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                  >
                                    This Year
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                  >
                                    This Month
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                  >
                                    This Week
                                  </Link>
                                </li>
                              </ul>
                            </div>
                            <div className="dropdown mb-3">
                              <Link
                                to="#"
                                className="dropdown-toggle btn btn-light fw-medium d-inline-flex align-items-center"
                                data-bs-toggle="dropdown"
                              >
                                <i className="ti ti-file-export me-2" />
                                Export
                              </Link>
                              <ul className="dropdown-menu  dropdown-menu-end p-3">
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                  >
                                    <i className="ti ti-file-type-pdf me-2" />
                                    Export as PDF
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                  >
                                    <i className="ti ti-file-type-xls me-2" />
                                    Export as Excel{" "}
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="card-body p-0 py-3">
                          <div className="px-3">
                            <div className="d-flex align-items-center flex-wrap">
                              <div className="d-flex align-items-center bg-white border rounded p-2 me-3 mb-3">
                                <span className="avatar avatar-sm bg-success rounded me-2 flex-shrink-0 ">
                                  <i className="ti ti-checks" />
                                </span>
                                <p className="text-dark">Present</p>
                              </div>
                              <div className="d-flex align-items-center bg-white border rounded p-2 me-3 mb-3">
                                <span className="avatar avatar-sm bg-danger rounded me-2 flex-shrink-0 ">
                                  <i className="ti ti-x" />
                                </span>
                                <p className="text-dark">Absent</p>
                              </div>

                            </div>
                          </div>
                          {/* Attendance List */}

                          <Table
                            dataSource={attendances}
                            columns={columns2}
                            Selection={false}
                          />
                          {/* /Attendance List */}
                        </div>
                      </div>
                    </div>
                    {/* /Attendance */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />
    </>
  );
};

export default StudentLeaves;
